interface TaxonomyRow {
  category: string;
  defaultSeverity: { label: string; variant: "danger" | "warning" | "info" };
  prototypePrio: { label: string; variant: "danger" | "warning" | "info" };
}

const TAXONOMY: TaxonomyRow[] = [
  {
    category: "Ontbrekend document",
    defaultSeverity: { label: "Hoog", variant: "danger" },
    prototypePrio: { label: "Hoog", variant: "danger" },
  },
  {
    category: "Incompleet veld",
    defaultSeverity: { label: "Midden", variant: "warning" },
    prototypePrio: { label: "Hoog", variant: "danger" },
  },
  {
    category: "GDPR / dataverwerkingsplan",
    defaultSeverity: { label: "Hoog", variant: "danger" },
    prototypePrio: { label: "Hoog", variant: "danger" },
  },
  {
    category: "Methodologische ambiguïteit",
    defaultSeverity: { label: "Midden", variant: "warning" },
    prototypePrio: { label: "Midden", variant: "warning" },
  },
  {
    category: "Interne inconsistentie",
    defaultSeverity: { label: "Midden", variant: "warning" },
    prototypePrio: { label: "Hoog", variant: "danger" },
  },
  {
    category: "Scope / commissieroute",
    defaultSeverity: { label: "Hoog", variant: "danger" },
    prototypePrio: { label: "Midden", variant: "warning" },
  },
  {
    category: "Opmaak / sjabloonfout",
    defaultSeverity: { label: "Laag", variant: "info" },
    prototypePrio: { label: "Midden", variant: "warning" },
  },
];

export function InstellingenPage() {
  return (
    <section>
      <div className="page-head">
        <div>
          <h1>Instellingen</h1>
          <p>AI-checks, issuetaxonomie en sjabloonbeheer</p>
        </div>
      </div>

      <div className="ua-grid">
        <div className="ua-col">
          <div className="card">
            <div className="card__head">
              <h2>Issuetaxonomie</h2>
              <span className="ua-muted-sm">7 categorieën actief</span>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>Categorie</th>
                  <th>Standaard ernst</th>
                  <th>Prototype prio</th>
                  <th>Actief</th>
                </tr>
              </thead>
              <tbody>
                {TAXONOMY.map((row) => (
                  <tr key={row.category}>
                    <td>{row.category}</td>
                    <td>
                      <span className={`badge badge--${row.defaultSeverity.variant}`}>
                        {row.defaultSeverity.label}
                      </span>
                    </td>
                    <td>
                      <span className={`badge badge--${row.prototypePrio.variant}`}>
                        {row.prototypePrio.label}
                      </span>
                    </td>
                    <td>
                      <span className="badge badge--success">Ja</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="border-border border-t px-5 py-[14px]">
              <button className="btn btn--ghost px-[14px] py-[6px] text-[13px]">
                + Categorie toevoegen
              </button>
            </div>
          </div>

          <div className="card">
            <div className="card__head">
              <h2>Vereiste bijlagen per route</h2>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>Route</th>
                  <th>Verplichte bijlagen</th>
                  <th>Versie</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>EA SHW Standaard</td>
                  <td className="ua-muted-sm">
                    Formulier, IC-formulier, vragenlijst, dataverwerkingsplan
                  </td>
                  <td>
                    <span className="badge badge--success">2025-v2</span>
                  </td>
                </tr>
                <tr>
                  <td>EA SHW Kwetsbare groep</td>
                  <td className="ua-muted-sm">+ Uitgebreid risicoassessment, wervingsprotocol</td>
                  <td>
                    <span className="badge badge--success">2025-v2</span>
                  </td>
                </tr>
                <tr>
                  <td>EA SHW Herziening</td>
                  <td className="ua-muted-sm">
                    Herzieningsformulier, responsdocument op voorwaarden
                  </td>
                  <td>
                    <span className="badge badge--warning">2024-v1 ⚠</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="ua-col">
          <div className="card">
            <div className="card__head">
              <h2>Governance-grenzen (v0)</h2>
            </div>
            <div className="card__body pt-3">
              <ul className="ua-col-sm-tight">
                <li className="control-item">
                  <span className="control-icon control-icon--ai">AI</span>
                  <div>
                    <div className="ua-bold-sm">AI blokkeert nooit een indiening</div>
                    <div className="ua-muted-xs">Pre-screening is altijd adviserend</div>
                  </div>
                </li>
                <li className="control-item">
                  <span className="control-icon control-icon--human">H</span>
                  <div>
                    <div className="ua-bold-sm">Onderzoeker heeft altijd een bezwaarroute</div>
                    <div className="ua-muted-xs">
                      Herzien, doorgaan met uitleg, of menselijke review aanvragen
                    </div>
                  </div>
                </li>
                <li className="control-item">
                  <span className="control-icon control-icon--human">H</span>
                  <div>
                    <div className="ua-bold-sm">Reviewer kan elke AI-bevinding verwerpen</div>
                    <div className="ua-muted-xs">Accepteren, verwerpen, bewerken of toevoegen</div>
                  </div>
                </li>
                <li className="control-item">
                  <span className="control-icon control-icon--human">H</span>
                  <div>
                    <div className="ua-bold-sm">AI geeft nooit ethisch advies</div>
                    <div className="ua-muted-xs">
                      Bureau en voorzitter beslissen en ondertekenen
                    </div>
                  </div>
                </li>
                <li className="control-item">
                  <span className="control-icon control-icon--ai">AI</span>
                  <div>
                    <div className="ua-bold-sm">Openbare AI-tools zijn niet toegestaan</div>
                    <div className="ua-muted-xs">
                      Gevoelige dossierinhoud mag niet extern verwerkt worden
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="panel-navy">
            <h2 className="mb-2 text-base">Evidence gaps (v0)</h2>
            <p className="m-0 mb-3 text-[13px]">
              Openstaande vragen die vóór pilotaanbeveling beantwoord moeten worden:
            </p>
            <ul className="ua-list-disc">
              <li>Validated issuetaxonomie op echte dossiers</li>
              <li>GDPR / DPO verwerkingsregels bevestigd</li>
              <li>Baseline metrics: herindieningstijd, cyclustijd</li>
              <li>Secretariaatsregels voor gereedheidscheck</li>
              <li>Bezwaar- en recoursepad onderzoeker</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
